import React, { useState } from "react";
import OrderRow from "../components/orders/OrderRow";
import ViewOrderModal from "../components/orders/ViewOrderModal";
import CheckPaymentModal from "../components/orders/CheckPaymentModal";
import UpdateStatusModal from "../components/orders/UpdateStatusModal";

const initialOrders = [
  {
    id: "#1001",
    date: "2024-01-15",
    customer: "Sophia Clark",
    total: "$150.00",
    status: "Pendiente",
    payment: "Pagado",
    paymentMethod: "Yape",
    paymentDate: "15/01/2024 - 10:30 AM",
    paymentProof: "https://via.placeholder.com/300x150.png?text=Comprobante+Yape",
    products: [{ name: "Camiseta", qty: 2, price: 50 }]
  },
  {
    id: "#1002",
    date: "2024-01-16",
    customer: "Liam Carter",
    total: "$220.00",
    status: "En Proceso",
    payment: "Pagado",
    paymentMethod: "Tarjeta de Crédito",
    paymentDate: "16/01/2024 - 09:15 AM",
    paymentProof: "https://via.placeholder.com/300x150.png?text=Comprobante+Tarjeta",
    products: [{ name: "Zapatos", qty: 1, price: 220 }]
  },
  {
    id: "#1003",
    date: "2024-01-17",
    customer: "Olivia Bennett",
    total: "$300.00",
    status: "Completado",
    payment: "Pagado",
    paymentMethod: "Yape",
    paymentDate: "17/01/2024 - 02:00 PM",
    paymentProof: "https://via.placeholder.com/300x150.png?text=Comprobante+Yape",
    products: [{ name: "Chaqueta", qty: 1, price: 300 }]
  },
];

const Pedidos = () => {
  const [orders, setOrders] = useState(initialOrders);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalType, setModalType] = useState(null); // "view", "payment", "status"

  const openModal = (order, type) => {
    setSelectedOrder(order);
    setModalType(type);
  };

  const closeModal = () => {
    setSelectedOrder(null);
    setModalType(null);
  };

  // Función que actualiza el estado del pedido
  const handleUpdateStatus = (orderId, newStatus) => {
    setOrders(prev =>
      prev.map(o => (o.id === orderId ? { ...o, status: newStatus } : o))
    );
    // Si el modal sigue abierto, también actualizamos selectedOrder
    if (selectedOrder && selectedOrder.id === orderId) {
      setSelectedOrder({ ...selectedOrder, status: newStatus });
    }
  };

  return (
    <div className="flex-1 px-4 sm:px-6 lg:px-8 py-8">
      <div className="mx-auto max-w-7xl">
        <h1 className="text-3xl font-bold tracking-tight text-white mb-2">Pedidos</h1>
        <p className="text-gray-400 mb-6">Gestiona y controla todos los pedidos de los clientes</p>

        <div className="overflow-x-auto rounded-lg border border-gray-800 bg-gray-900">
          <table className="min-w-full divide-y divide-gray-800">
            <thead className="bg-gray-800/50">
              <tr>
                <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold sm:pl-6">ID Pedido</th>
                <th className="px-3 py-3.5 text-left text-sm font-semibold">Fecha</th>
                <th className="px-3 py-3.5 text-left text-sm font-semibold">Cliente</th>
                <th className="px-3 py-3.5 text-left text-sm font-semibold">Total</th>
                <th className="px-3 py-3.5 text-left text-sm font-semibold">Estado</th>
                <th className="relative py-3.5 pl-3 pr-4 sm:pr-6 text-right text-sm font-semibold">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800">
              {orders.map(order => (
                <OrderRow key={order.id} order={order} openModal={openModal} />
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modalType === "view" && selectedOrder && (
        <ViewOrderModal isOpen={true} onClose={closeModal} order={selectedOrder} />
      )}
      {modalType === "payment" && selectedOrder && (
        <CheckPaymentModal isOpen={true} onClose={closeModal} order={selectedOrder} />
      )}
      {modalType === "status" && selectedOrder && (
        <UpdateStatusModal
          isOpen={true}
          onClose={closeModal}
          order={selectedOrder}
          onUpdate={handleUpdateStatus}
        />
      )}
    </div>
  );
};

export default Pedidos;
